import { createColumn, numberFormat } from "../../../../utils/helpers";
import { API_WAGES_REPORT_EXPORT } from "../../../../utils/apis";
import { reportExport, wagePeriodFilters } from "./reportUtils";
import dayjs from "dayjs";

const useWagesReport = () => {
  const tableColumns = () => [
    createColumn("staff_type", true, "Staff Type"),
    createColumn("total_staff", false, "Total Staff"),
    createColumn("total_collections", false, "Total Collections"),
    createColumn("total_wages", false, "Total Wages"),
    createColumn("total_commission", false, "Total Commission"),
    createColumn("total_fixed_wages", false, "Total Fixed Wages"),
    createColumn("total_bonus", false, "Total Bonus"),
    createColumn("approved_count", false, "Approved Count"),
    createColumn("pending_count", false, "Pending Count"),
  ];

  const tableData = (data: any) => {
    if (!data || !Array.isArray(data)) {
      return [];
    }

    return data?.map((item: any) => {
      return {
        ...item,
        staff_type: item?.staff_type,
        total_staff: numberFormat(item?.total_staff),
        total_collections: numberFormat(item?.total_collections),
        total_wages: numberFormat(item?.total_wages),
        total_commission: numberFormat(item?.total_commission),
        total_fixed_wages: numberFormat(item?.total_fixed_wages),
        total_bonus: numberFormat(item?.total_bonus),
        approved_count: numberFormat(item?.approved_count),
        pending_count: numberFormat(item?.pending_count),
      };
    });
  };

  // year alone gives the whole year; quarter/month/date range narrow it
  const exportData = reportExport(
    API_WAGES_REPORT_EXPORT,
    "wages_summary_report",
    ["xlsx"],
  );

  const externalFilters = wagePeriodFilters;
  const initialFilters = { year: dayjs().year() };

  return {
    tableTitle: "Wages Summary Report",
    tableData,
    tableColumns,
    exportData,
    initialFilters,
    externalFilters,
  };
};

export default useWagesReport;
